<script lang='ts'>
  import Modal from '../../../../../shared/javascripts/svelte/Components/Modal.svelte'
  import type { Storefront } from 'app/javascript/shared/javascripts/types/Storefront';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  export let showPublishModal: any;
  export let onClosePublishModal: any;
  export let callbacks: any;
  export let storefront : Storefront
  //@ts-ignore
  const APPURL = window.C.APP_URL
  let shareUrl = APPURL + "/"
  function publish() {
    callbacks.update({status: 'published'},
      function() {
        onClosePublishModal();
      }
    );
  };

  function prepUrls() {
    if (!storefront.published_urls) {
      storefront.published_urls = [];
    }
    return storefront.published_urls;
  }
</script>

<Modal bind:show={showPublishModal} closeOnBackgroundClick={true} fizzModal={true} size={'small'} fixedHeaderAndFooter={true}>
  <!-- svelte-ignore a11y-missing-attribute -->
  {#if storefront.dirty == false}
  <header class="fizz-space-between" data-grid-area="header">
    <h4 class="fizz-heading-4">Storefront Published</h4>
    <a on:click={onClosePublishModal}>
      <Icon type='X' extraClassNames='fizz-text-brand cursor-pointer' height="20" width="20"></Icon>
    </a>
  </header>
  <section data-grid-area="main" class="fizz-text-center fizz-stack-32">
    <Icon type='CheckCircle' extraClassNames='fizz-icon-32 fizz-margin-auto fizz-stack-16' height="32" width="32"></Icon>
    <p class="fizz-stack-4"><strong>Your storefront has been published to</strong></p>
    {#each prepUrls() as url}
      <p class="fizz-text-medium fizz-stack-12">
        {shareUrl}{url.short_url}
      </p>
      <p class="fizz-text-small">
        This is the URL that you share with your retailers.
      </p>
    {/each}
  </section>
  {:else}
  <div class="background-white welcome-modal align-center">
    <header class="modal__header padding--small align-left default-title--regular">
      Publish Storefront?
      <div class="cursor-pointer float-right h3 vertical-align-top" on:click={onClosePublishModal}>
        <Icon type='X' extraClassNames='fizz-text-brand' height="20" width="20"></Icon>
      </div>
    </header>

    <div class="default-body--regular margin--small padding--small">
      Are you sure you want to publish your storefront? All updates and changes will go live once you publish.
    </div>

    <footer class="modal__footer align-right padding--small">
      <button class="button button--small button--secondary" on:click={onClosePublishModal}>Cancel</button>
      <button class="button button--small button--primary margin-left--smallest" on:click={publish}>Publish</button>
    </footer>
  </div>
  {/if}
</Modal>